import { Provider } from "../../models/provider";

export enum AccountStoreEvents {
    Loaded = "accountStore:loaded"
}

export class AccountStore {
    public static featureToggles: number[];
    public static providers: Provider[];
}
